<template>
  <div class="minutes">
    <modal
      name="minutes"
      :shiftY="device.isMobile ? 0.1 : 0.5"
      :width="device.isMobile ? '90%' : '60%'"
      :height="device.isMobile ? '80%' : '50%'"
      :minWidth="300"
      :minHeight="300"
      :resizable="!device.isMobile"
      :draggable="!device.isMobile"
      :clickToClose="false"
    >
      <div class="minutes-header">
        <div>
          <span class="title">{{ $t('common.minutes') }}</span>
          <span v-if="sendable" class="sendable blink">{{ $t('pages.room.minutes.sendable') }}</span>
        </div>
        <div v-if="sendable" class="sendable-buttons">
          <stella-button variant="light" @click.native="onClickCancel">
            {{ $t('common.cancel') }}
          </stella-button>
          <stella-button variant="primary" @click.native="$emit('onClickSendMinutesText', innerMinutesText)">
            {{ $t('common.send') }}
          </stella-button>
        </div>
      </div>
      <div class="minutes-content">
        <textarea
          v-model="innerMinutesText"
          class="minutes-textarea"
          spellcheck="false"
        />
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'MinutesModal',
  props: {
    modal: Boolean,
    device: Object
  },
  data() {
    return {
      innerMinutesText: ''
    }
  },
  computed: {
    sendable: function() {
      return this.innerMinutesText != this.minutesText
    },
    ...mapGetters({
      minutesText: 'minutes/text'
    })
  },
  methods: {
    onClickCancel: function() {
      this.innerMinutesText = this.minutesText
    },
    ...mapMutations({
      setMinutesText: 'minutes/setText'
    })
  },
  watch: {
    modal: function(value) {
      if (value) {
        this.$modal.show('minutes')
      } else {
        this.$modal.hide('minutes')
      }
    },
    minutesText: function(value) {
      this.innerMinutesText = value
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.minutes-content {
  cursor: move;
  padding: 10px;
  width: 100%;
  height: calc(100% - 60px);
}

.minutes-textarea {
  color: $secondary-color;
  background: transparent;
  border: none;
  resize: none;
  width: 100%;
  height: 100%;
  outline: none;
}

.minutes-header {
  color: $text-color;
  cursor: move;
  width: 100%;
  min-height: 60px;
  padding: 10px;
  background: linear-gradient(90deg, #00b0e5, #00b0e5),
    linear-gradient(
      270deg,
      rgba(255, 255, 255, 0.2) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  border-radius: 8px 8px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  .title {
    font-weight: 600;
    user-select: none;
  }

  .sendable {
    font-size: 12px;
    font-weight: 600;
    user-select: none;
    display: block;
  }

  .sendable-buttons {
    button {
      margin: 10px 0 10px 10px;
      font-size: 12px;
      padding: 5px 10px;

      @include mq(md) {
        font-size: inherit;
        padding: 0.25rem 1.5rem;
      }
    }
  }
}
</style>
